import { render, staticRenderFns } from "./SlotWrapper.vue?vue&type=template&id=2e9b01ba&"
import script from "./SlotWrapper.vue?vue&type=script&lang=ts&"
export * from "./SlotWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports